<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <!-- 평가 이력 -->
      <c-table
        ref="table"
        title="LBL0003025"
        tableId="table"
        :columns="grid.columns"
        :data="grid.data"
        :columnSetting="false"
        :usePaging="false"
        :isFullScreen="false"
      >
      </c-table>
    </div>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'vendor-assess-history',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmVendorEvaluationId: '',
        vendorCd: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      listUrl: '',
      grid: {
        columns: [
          {
            name: 'vendorEvaluationKindName',
            field: 'vendorEvaluationKindName',
            // 평가구분
            label: 'LBL0003001',
            style: 'width:120px',
            align: 'center',
            sortable: true,
          },
          {
            // 평가점수
            label: 'LBL0003026',
            child: [
              {
                name: 'totalScore',
                field: 'totalScore',
                style: 'width:100px',
                // 총점
                label: 'LBL0003007',
                align: 'center',
                sortable: true,
              },
              {
                name: 'score',
                field: 'score',
                style: 'width:100px',
                // 평점
                label: 'LBL0003008',
                align: 'center',
                sortable: true,
              },
              {
                name: 'evaluationGradeName',
                field: 'evaluationGradeName',
                style: 'width:100px',
                // 등급
                label: 'LBL0003009',
                align: 'center',
                sortable: true,
              },
            ]
          },
          {
            name: 'evaluationDate',
            field: 'evaluationDate',
            // 평가기간
            label: 'LBL0003003',
            style: 'width:250px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'remarks',
            field: 'remarks',
            // 평가결과 종합
            label: 'LBL0003010',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.cim.vendor.evaluation.result.history.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {vendorCd: this.popupParam.vendorCd};
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
  }
};
</script>